/**
 * jv.Common.ScrollIntoView Module
 * ===============================
 *
 * Scroll an element into view if it isn't already.
 *
 * Usage
 * -----
 * ```
 * <div jv-scroll-into-view></div>
 * ```
 * Then `$scope.$emit('scrollIntoView', [speed=fast], [offset=100]);` to scroll the
 * element into view if it isn't already.
 */
angular.module('jv.Common.ScrollIntoView', [])

.directive('jvScrollIntoView', [function(){
    return {
        link: function($scope, iElm, iAttrs, controller) {
            var $body = $(document.body);
            $scope.$on('scrollIntoView', function(e, speed, offset) {
                var top = iElm.offset().top,
                    animate = true;
                if (speed === false) {
                    animate = false;
                }
                speed = speed || 'fast';
                offset = offset || 100;
                if (top < $body.scrollTop()) {
                    if (animate) {
                        $body.animate({ scrollTop: top - offset }, speed);
                    }
                }else {
                    $body.scrollTop(top);
                }
            });
        }
    };
}]);